export default "/react/gnezdoIcon-540a8cc5.svg";